const selectors = {
  showLoading: (state) => state.core.showLoading,
};

export { selectors };
